module.exports = __webpack_public_path__ + "img/Car.86e1673f.svg";